export default __webpack_public_path__ + "static/media/PowellCatLocation-07.7d3d3bec.jpg";